import { render, staticRenderFns } from "./SupportedList.vue?vue&type=template&id=0db2ae7e&scoped=true"
import script from "./SupportedList.vue?vue&type=script&lang=ts"
export * from "./SupportedList.vue?vue&type=script&lang=ts"
import style0 from "./SupportedList.vue?vue&type=style&index=0&id=0db2ae7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db2ae7e",
  null
  
)

export default component.exports